'use client'

import themeVariables from "@/config/theme/themeVariable";
import { Button } from "@mantine/core";
import Link from "next/link";
import { useEffect } from "react";
import Faq from "./_component/faq";
import Contact from "./_component/contact";

export default function QnAPage() {

  return (
    <div className="mx-auto px-4 flex flex-col items-center justify-start pt-32 bg-white dark:bg-gray-900 w-full">
      <Faq/>
      <Contact/>
    </div>
  )
}